<div class="history-card">

  <div *ngIf="isMyClinic" class="my-clinic">SISTEMA LEGADO - HISTÓRICO VIA INTEGRAÇÃO EM {{legacy}}</div>

  <ng-content class="no-pre_line"></ng-content>

</div>
